import getAreaCodesListByLangs from './getAreaCodeListByLangs';
import getLocaleListByLangs from './getLocaleListByLangs';
import checkAreaCodeExist from './checkAreaCodeExist';

const Area = {
  getAreaCodesListByLangs,
  getLocaleListByLangs,
  checkAreaCodeExist,
};

export default Area;
